import { createAsyncThunk } from '@reduxjs/toolkit'
import { ILogSource } from '../../../types/logs'
import { ThunkConfig } from '../../../types/store'
import { getUrl } from '../../../api/api'

export const fetchServerLogSources = createAsyncThunk<
    ILogSource[],
    void,
    ThunkConfig<string>
>('logsSlice/fetchServerLogSources', async (_, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    try {
        const { data } = await api.get<ILogSource[]>(getUrl(`/info/log_sources`))

        return  data ?? []
    } catch (e) {
        console.error(e)
        return rejectWithValue('Failed to fetch server log sources')
    }
})